<template>
  <h1 style="font-size: 400%; text-align: left">Hello 👋</h1>
  <div id="content" style="text-align: left; font-size: 100%">
    📧 Email me: <a href="mailto:1021130731@qq.com">1021130731@qq.com </a> <br>
    📌 Visit my blog: <a href="https://juejin.cn/user/2133495196168221">https://juejin.cn/user/2133495196168221</a><br>
    🎮 Love video games and can spend all day playing Stardew Valley <br>
    🇨🇳 来自中国, 在读大学牲
  </div>
</template>

<script>
import 'animate.css';
export default {
  name: "page2Right"
}
</script>

<style scoped>
a{
  color: #909399;
}
</style>